// -----------Pdp Accordion js-----------

$(document).ready(function() {

  // For mobile accordion
  $(".product-info-column .accordion-header").each(function(index) {
    if (index === 0) {
      // Open the first accordion by default
    //   $(this).next(".accordion-content").show();
    //   $(this).addClass('for-accordion-closing-icon');
      $(this).next(".accordion-content").hide();

    } else {
      $(this).next(".accordion-content").hide();
    }

    $(this).on("click", function(e) {
      e.preventDefault();
      e.stopPropagation();

      var content = $(this).next(".accordion-content");

      // Toggle only this accordion
      $(this).toggleClass('for-accordion-closing-icon');
      content.stop(true, true).slideToggle();
    });
  });

  // For desktop accordion
  $(".product-gallery-column .accordion-header").each(function(index) {
    if (index === 0) {
      // Open the first accordion by default
      $(this).next(".accordion-content").show();
      $(this).addClass('for-accordion-closing-icon');
    } else {
      $(this).next(".accordion-content").hide();
    }

    $(this).on("click", function(e) {
      e.preventDefault();
      e.stopPropagation();

      var content = $(this).next(".accordion-content");

      // Toggle only this accordion
      $(this).toggleClass('for-accordion-closing-icon');
      content.stop(true, true).slideToggle();
    });
  });

});

// {% comment %} Freebie_code {% endcomment %}
// document.addEventListener('DOMContentLoaded', function(evt){
//   document.body.addEventListener('click', function(evt){
//     const currentElement = evt.target;
//     const closest_lb = currentElement.closest('lb-button');
//     if (closest_lb){
//       evt.preventDefault();
//       evt.stopPropagation();
//       const freebieActive = window.offer.isEnable;
//       const mainProductSellEasy = closest_lb.closest('lb-upsell-flat-card').getAttribute('lb-variant-id');

//       let items = [
//         {
//           id: mainProductSellEasy,
//           quantity: 1
//         }
//       ];

//       if(freebieActive){
//       const freebie_id = window.offer.product;  
//         items.push({
//           id: freebie_id,
//           quantity: 1
//         });
//       }

//       console.log("Upsell button clicked and handleFreeGift function called----")
//       console.log('items', items)
//       const cartDrawerOpen = Boolean(document.querySelector('.show-close-cursor'));
//       addfreebieSellEasy(items, cartDrawerOpen);
//     }
//     else{
//       return;
//     }
//   });
// })

// async function addfreebieSellEasy(items, open) {
//   const response = await fetch('/cart/add.js', {
//     method: 'POST',
//     headers: {
//       "Content-Type": "application/json"
//     },
//     body: JSON.stringify({
//       items: items,
//       sections: ["cart-drawer","header"]
//     })
//   })
//   const result = await response.json();
//   document.dispatchEvent(new CustomEvent("cart:refresh"));
//   if(!open) document.querySelector('.cart-icon--bubble').click();
// }
// {% comment %} Freebie_code {% endcomment %}

// --------------Max Cart Total-----------------

document.addEventListener('DOMContentLoaded', function(evt){
  document.body.addEventListener('click', function(evt){
    const currentElement = evt.target;
    const closest_lb = currentElement.closest('lb-button');
    if (closest_lb){
      evt.preventDefault();
      console.log("upsell button clicked");
      setTimeout(() => {
        window.validateCartLimit();
      },2300);
    }
  });
})


// --------------Fetch shipping rates-----------------
window.validateCartLimit = async function () {

  console.log('🚀 validateCartLimit() called');

  const data = document.getElementById('cart-limit-data');

  if (!data) {
    // console.warn('❌ cart-limit-data element not found');
    return;
  }

  const subtotal = Number(data.dataset.subtotal);
  const threshold = Number(data.dataset.threshold);
  const country = data.dataset.country;
  const countryCode = data.dataset.countryCode;

  console.log('📦 Cart Data', {
    subtotal,
    threshold,
    country,
    countryCode
  });

  if (!threshold) {
    // console.warn('❌ No threshold configured for this market');
    return;
  }

  const zipCodes = {
    SA: '12211',
    BH: '973',
    KW: '13001',
    QA: '00000',
    OM: '111'
  };

  // console.log('📮 Using ZIP:', zipCodes[countryCode]);

  // console.log('📡 Preparing shipping rates...');

  await fetch('/cart/prepare_shipping_rates.json', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      shipping_address: {
        country: country,
        zip: zipCodes[countryCode] || ''
      }
    })
  });

  let rates;

  do {
    const response = await fetch('/cart/async_shipping_rates.json');
    const json = await response.json();

    // console.log('⏳ Waiting for shipping rates...', json);

    if (json.shipping_rates) {
      rates = json.shipping_rates;
      break;
    }

    await new Promise(resolve => setTimeout(resolve, 500));
  } while (true);

  console.log('🚚 Shipping Rates:', rates);

  if (!rates.length) {
    // console.warn('❌ No shipping rates returned');
    return;
  }

  const shipping = Math.round(parseFloat(rates[0].price) * 100);

  // console.log('💰 Shipping Cost:', shipping);

  const total = subtotal + shipping;

  console.log('🧮 Calculation', {
    subtotal,
    shipping,
    total,
    threshold
  });

  const shipping_estimate = document.querySelector('.shipping_estimate').innerText=shipping/100;
  const total_estimate = document.querySelector('.total_estimate').innerText=total/100;
  const checkoutButton = document.querySelector('.checkout_button_container');
  const cartPageCheckoutButton = document.querySelector('.cart-form button[name=checkout]');
  const messages = document.querySelectorAll('#cart-limit-message');

  if (!checkoutButton) {
    console.error('❌ Checkout button not found');
    return;
  }

  if (!messages) {
    console.error('❌ cart-limit-message element not found');
    return;
  }

  if (total > threshold) {

    const exceeded = total - threshold;

    console.log('⛔ Cart exceeds threshold');
    console.log('Exceeded Amount:', exceeded);

    if (checkoutButton) {
      checkoutButton.classList.add("checkout-disabled");
    }

    if (cartPageCheckoutButton) {
      cartPageCheckoutButton.classList.add("checkout-disabled");
      cartPageCheckoutButton.disabled = true;
    }

    const exceededFormatted = (exceeded / 100).toFixed(2);

    messages.forEach(message => {
      message.innerHTML = `
        <svg role="presentation" focusable="false" width="18" height="18" viewBox="0 0 18 18" style="color:red">
          <path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="currentColor"></path>
          <path d="M5.29289 6.70711L11.2929 12.7071L12.7071 11.2929L6.70711 5.29289L5.29289 6.70711ZM6.70711 12.7071L12.7071 6.70711L11.2929 5.2929L5.29289 11.2929L6.70711 12.7071Z" fill="#ffffff"></path>
        </svg>
        Please remove <strong><span class="money">AED ${exceededFormatted}</span></strong> worth of products<span class="continue"> to continue</span>.
      `;
    });

  } else {

    // console.log('✅ Cart is within threshold');

    if (checkoutButton) {
      checkoutButton.classList.remove("checkout-disabled");
    }

    if (cartPageCheckoutButton) {
      cartPageCheckoutButton.classList.remove("checkout-disabled");
      cartPageCheckoutButton.disabled = false;
    }

    // message.innerHTML = '';

  }

  // console.log('🏁 validateCartLimit() completed');
};

window.validateCartLimit();